/**
 * Mobile nav glyphs from Ready-for-Dev navBar (node 15019:184461).
 * Width and height are the asset's own size; the 32px hit target is the button, not a stretch of the glyph.
 */
function mobileNavSvg(width: number, height: number) {
  return {
    width,
    height,
    viewBox: `0 0 ${width} ${height}`,
    fill: "none" as const,
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none" as const,
    className: "block shrink-0",
  };
}

/** Figma logOut, 32×32. */
export function MobileNavLogoutIcon() {
  return (
    <svg {...mobileNavSvg(32, 32)} aria-hidden="true">
      <path
        d="M11.1866 6.57143C11.9139 6.57143 12.499 5.99821 12.499 5.28571C12.499 4.57321 11.9139 4 11.1866 4H7.24949C4.35133 4 2 6.30357 2 9.14286V22.8571C2 25.6964 4.35133 28 7.24949 28H11.1866C11.9139 28 12.499 27.4268 12.499 26.7143C12.499 26.0018 11.9139 25.4286 11.1866 25.4286H7.24949C5.80041 25.4286 4.62474 24.2768 4.62474 22.8571V9.14286C4.62474 7.72321 5.80041 6.57143 7.24949 6.57143H11.1866ZM29.6145 16.9107C30.1285 16.4071 30.1285 15.5929 29.6145 15.0946L22.1777 7.80357C21.6637 7.3 20.8325 7.3 20.324 7.80357C19.8154 8.30714 19.81 9.12143 20.324 9.61964L25.5188 14.7089H12.0615C11.3342 14.7089 10.7491 15.2821 10.7491 15.9946C10.7491 16.7071 11.3342 17.2804 12.0615 17.2804H25.5188L20.324 22.3696C19.81 22.8732 19.81 23.6875 20.324 24.1857C20.838 24.6839 21.6692 24.6893 22.1777 24.1857L29.6145 16.9107Z"
        fill="currentColor"
      />
    </svg>
  );
}

/** Figma brandedMarketPage, inset inside the 32px slot. */
export function MobileNavMarketIcon() {
  return (
    <svg {...mobileNavSvg(28.4445, 26.2564)} aria-hidden="true">
      <path
        d="M3.03651 23.2346H25.4079V3.02178H3.03651V23.2346ZM28.4445 23.3788C28.4445 25.0064 27.0934 26.2561 25.5152 26.2564H2.92922C1.35102 26.2561 6.79493e-06 25.0064 6.79493e-06 23.3788V2.87764C6.81944e-06 1.24997 1.35102 0.000316088 2.92922 1.54972e-06H25.5152C27.0934 0.000315584 28.4445 1.24997 28.4445 2.87764V23.3788Z"
        fill="currentColor"
      />
      <path
        d="M15.2523 6.97786C15.2523 6.22317 15.9905 5.61112 16.9007 5.61112H21.8443C22.7545 5.61112 23.4927 6.22317 23.4927 6.97786C23.4926 7.7325 22.7545 8.34461 21.8443 8.34461H16.9007C15.9905 8.34461 15.2524 7.7325 15.2523 6.97786Z"
        fill="currentColor"
      />
      <path
        d="M15.2523 11.0781C15.2523 10.3234 15.9905 9.71135 16.9007 9.71135H21.8443C22.7545 9.71135 23.4927 10.3234 23.4927 11.0781C23.4926 11.8327 22.7545 12.4448 21.8443 12.4448H16.9007C15.9905 12.4448 15.2524 11.8327 15.2523 11.0781Z"
        fill="currentColor"
      />
      <path
        d="M15.2523 15.1783C15.2523 14.4236 15.9905 13.8116 16.9007 13.8116H21.8443C22.7545 13.8116 23.4927 14.4236 23.4927 15.1783C23.4926 15.933 22.7545 16.5451 21.8443 16.5451H16.9007C15.9905 16.5451 15.2524 15.933 15.2523 15.1783Z"
        fill="currentColor"
      />
      <path
        d="M15.2523 19.2786C15.2523 18.5239 15.9905 17.9118 16.9007 17.9118H21.8443C22.7545 17.9118 23.4927 18.5239 23.4927 19.2786C23.4926 20.0332 22.7545 20.6453 21.8443 20.6453H16.9007C15.9905 20.6453 15.2524 20.0332 15.2523 19.2786Z"
        fill="currentColor"
      />
      <path
        d="M4.95177 19.2786C4.95177 18.5239 5.68994 17.9118 6.60014 17.9118H11.5438C12.454 17.9118 13.1922 18.5239 13.1922 19.2786C13.1921 20.0332 12.454 20.6453 11.5438 20.6453H6.60014C5.68999 20.6453 4.95185 20.0332 4.95177 19.2786Z"
        fill="currentColor"
      />
      <path
        d="M4.95177 15.1783C4.95177 14.4236 5.68994 13.8116 6.60014 13.8116H11.5438C12.454 13.8116 13.1922 14.4236 13.1922 15.1783C13.1921 15.933 12.454 16.5451 11.5438 16.5451H6.60014C5.68999 16.5451 4.95185 15.933 4.95177 15.1783Z"
        fill="currentColor"
      />
      <path
        d="M4.95177 11.0781C4.95177 10.3234 5.68994 9.71135 6.60014 9.71135H11.5438C12.454 9.71135 13.1922 10.3234 13.1922 11.0781C13.1921 11.8327 12.454 12.4448 11.5438 12.4448H6.60014C5.68999 12.4448 4.95185 11.8327 4.95177 11.0781Z"
        fill="currentColor"
      />
      <path
        d="M4.95177 6.97786C4.95177 6.22317 5.68994 5.61112 6.60014 5.61112H11.5438C12.454 5.61112 13.1922 6.22317 13.1922 6.97786C13.1921 7.7325 12.454 8.34461 11.5438 8.34461H6.60014C5.68999 8.34461 4.95185 7.7325 4.95177 6.97786Z"
        fill="currentColor"
      />
    </svg>
  );
}

/** Figma brandedCharts, inset inside the 32px slot. */
export function MobileNavChartsIcon() {
  return (
    <svg {...mobileNavSvg(28.4411, 28.4411)} aria-hidden="true">
      <path
        d="M5.66619 27.4244V8.4249C5.66619 7.85511 4.88415 7.55535 4.3226 7.55535C3.76105 7.55535 2.97901 7.85511 2.97901 8.4249V27.4244C2.97901 27.9942 3.65497 28.4411 4.21653 28.4411C4.77808 28.4411 5.66619 27.9942 5.66619 27.4244Z"
        fill="currentColor"
      />
      <path
        d="M15.3611 18.2965V0.991514C15.3611 0.421716 14.5941 8.70228e-06 14.0326 8.70228e-06C13.471 8.70228e-06 12.7577 0.421716 12.7577 0.991514V18.2965C12.7577 18.8663 13.5068 19.4053 14.0683 19.4053C14.6299 19.4053 15.3611 18.8663 15.3611 18.2965Z"
        fill="currentColor"
      />
      <path
        d="M25.5367 26.0249V8.81215C25.5367 8.24235 24.7385 7.95981 24.177 7.95981C23.6154 7.95981 22.865 8.24235 22.865 8.81215V26.0249C22.865 26.5947 23.6035 26.9325 24.1651 26.9325C24.7266 26.9325 25.5367 26.5947 25.5367 26.0249Z"
        fill="currentColor"
      />
      <path d="M8.61854 13.2119H6.79493e-06V23.3637H8.61854V13.2119Z" fill="currentColor" />
      <path d="M17.8932 3.62623H9.96708V12.7776H17.8932V3.62623Z" fill="currentColor" />
      <path d="M28.4411 12.5615H19.8832V20.6895H28.4411V12.5615Z" fill="currentColor" />
    </svg>
  );
}

/** Figma brandedEditCurve, pencil included, inset inside the 32px slot. */
export function MobileNavCurveIcon() {
  return (
    <svg {...mobileNavSvg(28.4444, 24.0684)} aria-hidden="true">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.636333 14.0872L6.79493e-06 12.5046L2.64088 11.0648L3.3237 12.5883C4.26299 14.9247 5.43202 17.1556 6.56734 18.7049C7.16236 19.517 7.7037 20.1489 8.20688 20.3556C9.27591 20.7946 10.1136 20.3755 10.8348 19.5643C11.8647 18.4057 12.6922 16.6092 13.5032 14.758C14.6325 12.1805 15.7159 9.49532 16.9903 7.76937C18.123 6.23527 19.4265 5.3807 20.9203 5.43343C21.2974 5.44672 23.2967 5.43706 25.1749 8.40168C26.4946 10.4847 27.4886 12.6528 27.6075 12.9034L28.3327 14.4322C29.0134 15.9115 26.3899 17.6538 25.7368 16.1404L25.0117 14.6116C24.902 14.3805 24.009 12.4176 22.7918 10.4963C21.8928 9.07724 21.0118 8.94059 20.8313 8.93417C19.9616 8.90349 19.3645 9.77434 18.7376 10.8196C17.8153 12.3575 17.0053 14.4019 16.1456 16.3642C15.1714 18.5878 14.1257 20.7053 12.8885 22.097C11.3425 23.8362 9.51962 24.6037 7.228 23.6627C6.36723 23.3093 5.33428 22.3825 4.31635 20.9934C3.03274 19.2417 1.69831 16.7287 0.636333 14.0872Z"
        fill="currentColor"
      />
      <path
        d="M12.1564 0.361471C12.6219 -0.0595358 13.3507 -0.177761 13.7143 0.361292L14.4254 1.34929C14.789 1.88835 14.5618 2.4256 14.0963 2.8466L5.92679 10.1883L3.04763 10.5205L4.17083 7.58627L12.1564 0.361471Z"
        fill="currentColor"
      />
    </svg>
  );
}

/** Figma menuKebab, 32×32. */
export function MobileNavKebabIcon() {
  return (
    <svg {...mobileNavSvg(32, 32)} aria-hidden="true">
      <path
        d="M19 5C19 5.39397 18.9224 5.78407 18.7716 6.14805C18.6209 6.51203 18.3999 6.84274 18.1213 7.12132C17.8427 7.3999 17.512 7.62087 17.1481 7.77164C16.7841 7.9224 16.394 8 16 8C15.606 8 15.2159 7.9224 14.8519 7.77164C14.488 7.62087 14.1573 7.3999 13.8787 7.12132C13.6001 6.84274 13.3791 6.51203 13.2284 6.14805C13.0776 5.78407 13 5.39397 13 5C13 4.60603 13.0776 4.21593 13.2284 3.85195C13.3791 3.48797 13.6001 3.15726 13.8787 2.87868C14.1573 2.6001 14.488 2.37913 14.8519 2.22836C15.2159 2.0776 15.606 2 16 2C16.394 2 16.7841 2.0776 17.1481 2.22836C17.512 2.37913 17.8427 2.6001 18.1213 2.87868C18.3999 3.15726 18.6209 3.48797 18.7716 3.85195C18.9224 4.21593 19 4.60603 19 5ZM13 16C13 14.3438 14.3438 13 16 13C17.6562 13 19 14.3438 19 16C19 17.6562 17.6562 19 16 19C14.3438 19 13 17.6562 13 16ZM19 27C19 28.6562 17.6562 30 16 30C14.3438 30 13 28.6562 13 27C13 25.3438 14.3438 24 16 24C17.6562 24 19 25.3438 19 27Z"
        fill="currentColor"
      />
    </svg>
  );
}
